import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '@/lib/queryKeys';
import { getBackofficeUser, tryLinkBackofficeUser } from '@/services/backofficeAuth';

export function useBackofficeUserQuery(userId: string | null) {
    return useQuery({
        queryKey: queryKeys.backofficeAuth.user(userId),
        queryFn: async () => {
            await tryLinkBackofficeUser();
            return getBackofficeUser();
        },
        enabled: !!userId,
        staleTime: 5 * 60 * 1000,
        retry: 1,
    });
}
